import imgWelton71 from "./img-welton7 (1).webp";
import imgWelton72 from "./img-welton7 (2).webp";
import imgWelton73 from "./img-welton7 (3).webp";
import imgWelton74 from "./img-welton7 (4).webp";

const imgWelton7 = [imgWelton71, imgWelton72, imgWelton73, imgWelton74];

export default imgWelton7;
